import React from "react";
import { useSelector } from "react-redux";
import { selectJobDetailsSection } from "../../../redux/selectors";
import { getHCConfigurationFlags } from '../Mechanical/hcRequirementsVisibility';

const PrintHC = () => {
  const hcDetails = useSelector(state => selectJobDetailsSection(state, 'hcRequirements'));
  const generalSpecDetails = useSelector(state => selectJobDetailsSection(state, 'generalStation'));
  const generalStations = Array.isArray(generalSpecDetails) ? generalSpecDetails : [];
  const renderedZones = new Set();
  const zones = (Array.isArray(hcDetails) ? hcDetails : []).flatMap(detail => {
    if (!detail || renderedZones.has(detail.Zone)) return [];
    const generalDetail = generalStations.find(station => station?.Zone === detail.Zone);
    if (generalDetail?.TrackerType !== 'HC') return [];
    renderedZones.add(detail.Zone);
    return [{ detail, generalDetail }];
  });

  if (!zones.length) return null;

  return (
    <div>
      <h2 className="print-section-header">HC Requirements Summary</h2>
      {zones.map(({ detail, generalDetail }) => {
        const { isBoosterOrFloodedSuction, isSuctionLift } = getHCConfigurationFlags(generalDetail.StationConfiguration);
        // Keep field order and sources aligned with the paired rows in HCRequirements.
        const rows = [
          ...(!isBoosterOrFloodedSuction ? [
            [['Feet Of Lift', generalDetail.FeetOfLift], ['Suction Line Material', detail.SuctionLineMaterial]],
            [['Station Drawing From', detail.StationDrawingFrom], ['Prime System', generalDetail.PrimeSystem]],
            [['Suction Lines By', detail.SuctionLinesBy], ['Vacuum Prime Detail', detail.VacuumPrimeDetail]],
            [['Custom Provider Details', detail.CustomProviderDetails], ['Foot Valve Required', detail.FootValveRequired]],
            [['Suction Line Config', detail.SuctionLineConfig], ['Foot Valve Details', detail.FootValveDetails]],
          ] : []),
          ...(!isSuctionLift ? [
            [['Backflow Preventer', detail.BackflowPreventer], ['Inlet Pressure Control', detail.InletPressureControl]],
            [['Dynamic Inlet PSI', generalDetail.DynamicInletPSI]],
          ] : []),
        ];

        return (
          <div className="section" key={detail.Zone}>
            <h3 className="print-zone-label">Zone: {detail.Zone}</h3>
            <table className="table table-bordered full-width">
              <tbody>
                {rows.map(row => (
                  <tr key={row[0][0]}>
                    {row.map(([label, value]) => (
                      <td className="col-md-6" key={label}><strong>{label}: </strong>{value ?? ''}</td>
                    ))}
                    {row.length === 1 && <td className="col-md-6" />}
                  </tr>
                ))}
              </tbody>
            </table>
            <p><strong>Comments:</strong><br />{detail.Comments}</p>
            <br className="clearfix" />
          </div>
        );
      })}
    </div>
  );
};

export default PrintHC;
